import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { Reveal, Eyebrow } from "../components/Reveal";
import { LEGACY_DEVELOPMENTS } from "./Home";

const LOCATIONS = ["Sardhana", "Lawar", "Ramraj", "Putthi", "Khardoni", "Mawana", "Kharkhadi", "Kharkhauda", "Modinagar"];

export default function RealEstate() {
  return (
    <div data-testid="real-estate-page" className="pt-28 sm:pt-36">
      <SEO title="RK Builders — Real Estate"
        description="RK Builders undertakes residential projects, townships, developed land, and villa developments across Sardhana, Lawar, Ramraj, Putthi, Khardoni, Mawana, Kharkhadi, Kharkhauda, Modinagar, and upcoming locations." />

      <header className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="/images/realestate-villa.jpg" alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#060A12]/60 to-[#060A12]" />
        </div>
        <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 pb-24 pt-8">
          <Eyebrow>The Building Arm</Eyebrow>
          <h1 className="font-serif font-light text-4xl sm:text-6xl tracking-tight text-[#FBF9F5] mt-4 leading-[1.05]">
            RK <span className="italic text-[#C5A059]">Builders</span>
          </h1>
          <p className="text-base text-[#94A3B8] leading-loose mt-8 max-w-2xl">
            RK Builders undertakes residential projects, townships, developed land, and villa developments across
            Sardhana, Lawar, Ramraj, Putthi, Khardoni, Mawana, Kharkhadi, Kharkhauda, Modinagar, and other upcoming
            locations.
          </p>
          <div className="flex flex-wrap gap-4 mt-10">
            <Link to="/projects" data-testid="re-all-projects-btn"
              className="text-[11px] uppercase tracking-[0.22em] font-semibold bg-[#C5A059] text-[#060A12] px-8 py-4 hover:bg-[#d6b678] transition-colors duration-300">
              Our Developments
            </Link>
            <Link to="/site-visit" data-testid="re-site-visit-btn"
              className="text-[11px] uppercase tracking-[0.22em] font-semibold border border-white/25 text-[#FBF9F5] px-8 py-4 hover:border-[#C5A059] hover:text-[#C5A059] transition-colors duration-300">
              Book a Site Visit
            </Link>
            <Link to="/landowner-partnerships" data-testid="re-landowner-btn"
              className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#94A3B8] px-8 py-4 hover:text-[#FBF9F5] transition-colors duration-300">
              Landowner Partnerships
            </Link>
          </div>
        </div>
      </header>

      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20">
        <Reveal>
          <Eyebrow>Where We Build</Eyebrow>
          <h2 className="font-serif text-3xl sm:text-4xl text-[#FBF9F5] mt-3 mb-12">Locations</h2>
        </Reveal>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-white/5 border border-white/5">
          {LOCATIONS.map((loc, i) => (
            <Link key={loc} to="/projects" data-testid={`location-${loc.toLowerCase()}`}
              className="group bg-[#060A12] p-6 sm:p-8 text-center hover:bg-[#0B1320] transition-colors duration-500">
              <span className="font-serif text-xl text-[#C5A059]/30">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="font-serif text-xl sm:text-2xl text-[#FBF9F5] mt-2 group-hover:text-[#C5A059] transition-colors duration-500">{loc}</h3>
            </Link>
          ))}
        </div>
      </section>

      <section className="bg-[#0B1320] border-y border-[#C5A059]/10 py-24">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
          <Reveal>
            <Eyebrow>Our Development Legacy</Eyebrow>
            <h2 className="font-serif text-3xl sm:text-4xl text-[#FBF9F5] mt-3 mb-12">Developments That Define Our Journey</h2>
          </Reveal>
          <div className="flex flex-wrap items-center" data-testid="re-legacy-wall">
            {LEGACY_DEVELOPMENTS.map((name, i) => (
              <div key={name} className="flex items-center">
                <Reveal delay={i * 0.05} className="group relative py-3 sm:py-4">
                  <span className="block font-serif font-light text-xl sm:text-3xl text-[#FBF9F5]/75 group-hover:text-[#C5A059] transition-colors duration-500 cursor-default leading-tight">
                    {name}
                  </span>
                  <span className="block h-4 text-[9px] uppercase tracking-[0.25em] text-[#94A3B8] opacity-0 group-hover:opacity-100 transition-opacity duration-500 mt-1">
                    An RK Builders Development
                  </span>
                </Reveal>
                {i < LEGACY_DEVELOPMENTS.length - 1 && (
                  <span className="mx-4 sm:mx-7 w-px h-7 sm:h-10 bg-[#C5A059]/25 shrink-0 self-center" aria-hidden="true" />
                )}
              </div>
            ))}
          </div>
          <Reveal className="mt-10">
            <Link to="/projects" data-testid="re-developments-btn"
              className="inline-block text-[11px] uppercase tracking-[0.22em] font-semibold border border-[#C5A059]/60 text-[#C5A059] px-10 py-4 hover:bg-[#C5A059] hover:text-[#060A12] transition-colors duration-300">
              Our Developments
            </Link>
          </Reveal>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 grid grid-cols-1 md:grid-cols-2 gap-6">
        <Reveal className="border border-white/10 p-10 sm:p-14 hover:border-[#C5A059]/40 transition-colors duration-500">
          <Eyebrow>For Buyers</Eyebrow>
          <h3 className="font-serif text-3xl text-[#FBF9F5] mt-3">Enquire About a Property</h3>
          <p className="text-sm text-[#94A3B8] leading-loose mt-5">
            Tell us the location, property type, and budget you are considering. The relevant project team
            responds directly.
          </p>
          <Link to="/contact?type=property" data-testid="re-property-enquiry-btn"
            className="inline-block mt-8 text-[11px] uppercase tracking-[0.2em] font-semibold bg-[#C5A059] text-[#060A12] px-8 py-4 hover:bg-[#d6b678] transition-colors duration-300">
            Enquire Now
          </Link>
        </Reveal>
        <Reveal delay={0.1} className="border border-white/10 p-10 sm:p-14 hover:border-[#C5A059]/40 transition-colors duration-500">
          <Eyebrow>For Landowners</Eyebrow>
          <h3 className="font-serif text-3xl text-[#FBF9F5] mt-3">Develop Your Land With Us</h3>
          <p className="text-sm text-[#94A3B8] leading-loose mt-5">
            Joint development, land sale, project collaboration, or development partnership — start the
            conversation with our real estate team.
          </p>
          <Link to="/landowner-partnerships" data-testid="re-landowner-card-btn"
            className="inline-block mt-8 text-[11px] uppercase tracking-[0.2em] font-semibold border border-[#C5A059]/60 text-[#C5A059] px-8 py-4 hover:bg-[#C5A059] hover:text-[#060A12] transition-colors duration-300">
            Landowner Partnerships
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
